export default (Base = HTMLElement) =>
  class ImgLoadComplete extends Base {
    #img;
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback?.();
      const img = this.querySelector("img");
      if (img) {
        this.loadCompleteFromImg(img);
      } else {
        const observer = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (mutation.addedNodes.length) {
              const img = this.querySelector("img");
              if (img) {
                this.loadCompleteFromImg(img);
                observer.disconnect();
              }
            }
          });
        });
        observer.observe(this, { childList: true });
      }
    }

    loadCompleteFromImg(img) {
      this.loadComplete = img.complete;
      img.addEventListener("load", () => {
        this.loadComplete = img.complete;
      });
    }

    set loadComplete(value) {
      this.toggleAttribute("load-complete", value);
    }

    get loadComplete() {
      return this.hasAttribute("load-complete");
    }
  };
